import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    paddingBottom: 0,
    paddingLeft: 0,
    marginLeft: 0,
  },
  content: {
    zIndex: 1,
    height: '100%',
    width: '100%',
    marginLeft: 48,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));
